// Texte und Datumsformate rund um Versionen (Spec 2026-10-20).

import { rt, fmtStamp } from './reportTexts';

const STAMP = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };

export function formatStamp(iso) {
  return new Date(iso).toLocaleString('de-DE', STAMP);
}

export function formatListStamp(iso, now = new Date()) {
  const d = new Date(iso);
  const sameDay = d.getFullYear() === now.getFullYear()
    && d.getMonth() === now.getMonth()
    && d.getDate() === now.getDate();
  if (!sameDay) return formatStamp(iso);
  return `Heute, ${d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}`;
}

export function versionLine(v, lang = 'de') {
  const stamp = lang === 'en' ? fmtStamp('en', v.created_at) : formatStamp(v.created_at);
  return v.kind === 'named'
    ? rt(lang, 'version.named', { label: v.label, stamp })
    : rt(lang, 'version.auto', { stamp });
}

export function bannerText(v) {
  const stamp = formatStamp(v.created_at);
  return v.kind === 'named'
    ? `Du siehst den Stand „${v.label}“ vom ${stamp}. Nur ansehen.`
    : `Du siehst den automatischen Stand vom ${stamp}. Nur ansehen.`;
}

export function copyName(name, v) {
  return `${name} (Stand ${formatStamp(v.created_at)})`;
}
